var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { makeObservable, observable, runInAction } from 'mobx';
import { ModelHistory } from '~/models/model.history';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
export let ServiceHistory = class ServiceHistory extends BaseSingletonService {
    history;
    constructor() {
        super();
        makeObservable(this);
    }
    getHistory(fileId) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.ownershipHistory}`, {
                params: {
                    fileId,
                },
            })
                .then(response => {
                runInAction(() => (this.history = plainToInstance(ModelHistory, response.data.collection)));
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceHistory.prototype, "history", void 0);
ServiceHistory = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [])
], ServiceHistory);
